export default __webpack_public_path__ + "static/media/shackles_of_the_dandelion_gladiator.c234ef6b.png";